export default "__VITE_ASSET__e00c9417__"